import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AmbienteService } from '../../../services/ambiente.service';
import { ToastService } from '../../../services/toast.service';
import { Ambiente } from '../../../types/Ambiente.type';
import { Base } from '../../../types/Base.type';

@Component({
  selector: 'app-novo-ambiente-dialog',
  templateUrl: './novo-ambiente-dialog.component.html',
  styleUrl: './novo-ambiente-dialog.component.css',
})
export class NovoAmbienteDialogComponent {
  @Input() visivel: boolean = false;
  @Input() bases!: Base[];
  @Input() cliente: string = "";
  @Output() public fechar = new EventEmitter();

  ambiente: Ambiente = {} as Ambiente;

  ambienteEnviado: boolean = false;

  constructor(private ambienteService: AmbienteService, private toastService: ToastService){}

  escondeDialog() {
    this.visivel = false;
    this.ambiente = {} as Ambiente;
    this.bases = {} as Base[];
    this.ambienteEnviado = false;

    this.fechar.emit();
  }

  salvar() {
    this.ambienteEnviado = true;

    if (this.ambiente.ambiente?.trim() && this.ambiente.baseId?.trim()) {
      this.ambiente.clienteId = this.cliente;
      
      this.ambienteService.post(this.ambiente).subscribe({
        next: () => {
          this.toastService.sucesso("Sucesso", "Ambiente Salvo com sucesso");
          this.escondeDialog();
        },
        error: (value) => {
          this.toastService.erro("Erro", "Erro ao salvar o ambiente: " + value.error);
        }
      })
    }
  }
}
